/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
export const Image = styled.img`
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;
`;
export const Background = styled.div`
  display: block;
  justify-content: center;
  min-height: 100%;
  width: 100%;
  @media (max-width: 480px) {
    width: 100%;
  }
`;
export const Title = styled.h3`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.8;
`;
export const SubTitle = styled.h5`
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2%;
`;
export const Description = styled.p`
  text-align: center;
  line-height: 1;
  padding: 0 10%;
  @media (max-width: 480px) {
    padding: 0 5%;
  }
`;
export const ButtonContainer = styled.div`
  display: block;
  width: 100%;
  text-align: center;
`;

export const ButtonGroup = styled.div`
  margin: 1rem;
  padding: 2rem 2rem;
  text-align: center;
`;

export const VerifyPhoneText = styled.h5`
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2%;
`;

export const VerifyButtonText = styled.span`
  color: blue;
  text-decoration: underline;
  cursor: pointer;
`;
